<template>
  <div class="question-padding">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({})
</script>

<style lang="postcss">
.question-padding {
  display: grid;
  grid-template-rows: auto 1fr;
  padding: var(--attest-spacing-4);
  height: 100%;
}
</style>
